import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { GridRow } from 'dibs-elements/exports/Grid';
import HpRespPromoModulePromoItem from './HpRespPromoModulePromoItem';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

import { HpRespPromoModulePrimary_componentModule } from './__generated__/HpRespPromoModulePrimary_componentModule.graphql';

type Props = {
    componentModule: HpRespPromoModulePrimary_componentModule;
    useLazyLoadImages: boolean;
    isMobile: boolean;
};

const HpRespPromoModulePrimary: FC<Props> = ({ componentModule, useLazyLoadImages, isMobile }) => {
    if (!componentModule) {
        return null;
    }

    const { title } = componentModule;
    const items = (componentModule.items || []).filter(filterNulls);
    const isSinglePromo = items.length === 1;

    const handleInitialDisplay = ({ inViewport }: { inViewport: boolean }): void => {
        if (componentModule && inViewport) {
            trackPromoImpressions({ items, startingIndex: 0 });
        }
    };

    return (
        <HpRespModuleContainerOld addTopGap={!title}>
            <HpRespModuleContainerOld.Header>{title}</HpRespModuleContainerOld.Header>
            <SharedInViewport stopWhenInViewport onInViewportChange={handleInitialDisplay}>
                <GridRow>
                    {items.map((promotion, index) => (
                        <HpRespPromoModulePromoItem
                            key={promotion?.cmsId || index}
                            index={index}
                            promotion={promotion}
                            useLazyLoadImages={useLazyLoadImages}
                            onClick={() => trackPromoClick({ item: promotion, index })}
                            isSinglePromo={isSinglePromo}
                            isMobile={isMobile}
                        />
                    ))}
                </GridRow>
            </SharedInViewport>
        </HpRespModuleContainerOld>
    );
};

export default createFragmentContainer(HpRespPromoModulePrimary, {
    componentModule: graphql`
        fragment HpRespPromoModulePrimary_componentModule on PromoModule {
            title
            items {
                cmsId
                linkData {
                    # path is used in PromoTrackingOld.js
                    path
                }
                ...HpRespPromoModulePromoItem_promotion
            }
        }
    `,
});
